// MUTATIONS
export const SET_OVP_JOB_CONDITIONS = 'setOvpJobConditions';
export const SET_GLOBAL_OVP_JOB_CONDITIONS = 'setGlobalOvpJobConditions';
export const SET_CURRENT_OVP_JOB_CONDITIONS = 'setCurrentOvpJobConditions';
export const SET_IS_LOADING = 'isLoading';
export const SET_IS_ACTIVE_REQUEST = 'setIsActiveRequest';
export const SET_IS_TEMPLATE = "setIsTemplate";
export const SET_SELECTED_OVP_USERS = 'setSelectedUsers';
export const UNSET_SELECTED_OVP_USERS = 'unsetSelectedUsers';
export const CLEAR_SELECTED_OVP_USERS = 'clearSelectedUsers';

// ACTIONS
export const ACTION_GET_OVP_JOB_CONDITIONS = 'getOvpJobConditions';
export const ACTION_GET_GLOBAL_OVP_JOB_CONDITIONS = 'getGlobalOvpJobConditions';
export const ACTION_CREATE_OVP_JOB_CONDITION = "createOvpJobCondition";
export const ACTION_UPDATE_OVP_JOB_CONDITION = "updateOvpJobCondition";
export const ACTION_REMOVE_OVP_JOB_CONDITION = "removeOvpJobCondition";
export const ACTION_GENERATE_OVP_FORMS = "generateOvpForms";
export const ACTION_APPROVE_OVP_JOB_CONDITIONS = "approveUserOvpJobConditions";

// GETTERS
export const GET_OVP_JOB_CONDITIONS = 'ovpJobConditions';
export const GET_GLOBAL_OVP_JOB_CONDITIONS = 'globalOvpJobConditions';
export const GET_CURRENT_OVP_JOB_CONDITION = 'currentOvpJobConditions';
export const GET_IS_LOADING = 'isLoading';
export const GET_IS_ACTIVE_REQUEST = 'isActiveRequest';
export const GET_IS_TEMPLATE = "isTemplate";
export const GET_SELECTED_OVP_USERS = "selectedUsers";